.readonly_TextBox_22f110e{cursor:default;opacity:0.3}